import React from "react";
import { ContentPage } from "@/components/ContentPage";

const sections = [
  {
    id: "included",
    heading: "What's included",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>Third-party liability cover as mandated under the Motor Vehicles Act.</li>
        <li>Damage to the eBikeGo vehicle from accidents, subject to the rider excess.</li>
        <li>Theft cover with a valid FIR filed within 24 hours of the incident.</li>
      </ul>
    ),
  },
  {
    id: "excess",
    heading: "Rider excess",
    body: (
      <>
        <p>
          Every claim has a rider-excess component — the portion of the damage
          bill the rider is liable for before insurance kicks in. The excess
          amount is shared with you at the time of booking and varies by
          vehicle category, the nature of the damage and the plan you choose.
        </p>
        <p>
          Please refer to your booking confirmation for the exact excess
          applicable to your rental. Our support team is happy to walk you
          through the excess before you ride — just reach out on the
          Support page.
        </p>
      </>
    ),
  },
  {
    id: "excluded",
    heading: "What's not covered",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>Damage from riding without a helmet, under influence or by an unlisted rider.</li>
        <li>Cosmetic damage such as scratches under ₹500.</li>
        <li>Tyre, tube, and puncture repair are billed at actuals.</li>
        <li>Loss of accessories issued at handover (helmet, charger, keys).</li>
      </ul>
    ),
  },
  {
    id: "claim",
    heading: "How to raise a claim",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>Ensure everyone is safe. Call emergency services if required.</li>
        <li>Call our 24×7 support number and share photos of the damage.</li>
        <li>File an FIR at the nearest police station within 24 hours for theft or major accidents.</li>
        <li>Submit the FIR copy and any medical / repair bills to info@theebg.com.</li>
      </ol>
    ),
  },
];

const InsurancePolicy = () => (
  <ContentPage
    testId="insurance-policy-page"
    eyebrow="Insurance & Damage"
    title="Ride covered. Every ride."
    subtitle="Insurance is included on every rental — here's exactly what it covers and the rider's excess."
    sections={sections}
  />
);

export default InsurancePolicy;
